module.exports = __webpack_public_path__ + "img/anzi.8642da33.png";